import styled from "styled-components";

export const QuantityInput = styled.input`
  border-radius: 5px;
  text-align: center;
  width: 70px;
  height: 41px;
  border: 1px solid #909090;
  // margin-right: 12px;
`;
